import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

import { Button, FormHelperText, Stack, useMediaQuery } from '@mui/material';

import OtpInput from 'react-otp-input';

import { string, ValidationError } from 'yup';

import ToastContext from '../../../../Context/ToastContext';

import { COLORS } from '../../../../Constant/COLORS';

import { TypoPoppins, TypoSerif } from '../../../../Components/Typo';

import { useFormContext } from './FormContext';

function CodeVerification({ handleCodeVerification, title, description, ...props }) {
  const { showToastMessage } = useContext(ToastContext);
  const { nextStep } = useFormContext();

  const [error, setError] = useState(null);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');

  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

  const handleSubmit = async event => {
    try {
      event.preventDefault();
      setIsSubmitDisabled(true);
      setError(null);

      const validatedOTP = await schema.validate(verificationCode);

      const error = await handleCodeVerification(validatedOTP);
      if (error) {
        error?.shouldDisplayError && setError(error.message);
        return undefined;
      }

      nextStep();
    } catch (error) {
      if (error instanceof ValidationError) {
        setError(error.message);
        return undefined;
      }

      showToastMessage('Something went wrong');
    } finally {
      setIsSubmitDisabled(false);
    }
  };

  return (
    <Stack
      component='form'
      gap={1}
      onSubmit={handleSubmit}
      width='min(100%,444px)'
      mx='auto'
      alignItems='center'
      my={8}
      textAlign='center'>
      <TypoSerif variant='h4' variantMapping={{ h4: 'h1' }}>
        {title}
      </TypoSerif>
      <TypoPoppins mb={4}>{description}</TypoPoppins>

      <OtpInput
        containerStyle={{ gap: '1em' }}
        numInputs={4}
        value={verificationCode}
        onChange={value => setVerificationCode(value)}
        isInputNum
        shouldAutoFocus
        inputStyle={{
          boxSizing: 'border-box',
          width: isMobile ? '40px' : '50px',
          height: isMobile ? '40px' : '50px',
          borderColor: COLORS.grey1,
          borderStyle: 'solid',
          borderWidth: '1.5px',
          boxShadow: 'initial',
          borderRadius: '6px',
          fontSize: '1.5rem',
        }}
      />

      {error && (
        <FormHelperText error sx={{ textAlign: 'center' }}>
          {error}
        </FormHelperText>
      )}

      {props.helperText && (
        <TypoPoppins color='grey.400' variant='caption'>
          {props.helperText}
        </TypoPoppins>
      )}

      <Button sx={{ mt: 4, width: 3 / 5 }} color='blue' type='submit' disabled={isSubmitDisabled}>
        Submit
      </Button>
    </Stack>
  );
}

const schema = string()
  .required('Verification code is required to continue')
  .length(4, 'Entered verification code is incorrect');

CodeVerification.propTypes = {
  handleCodeVerification: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default CodeVerification;
